module.exports = __webpack_public_path__ + "static/img/study_report_official.8fc9f6aa.png";